import React from 'react'
import ReportingForm from '../ReportingForm'

const STATUS = { ADHOC: 'adhoc', EXISTING: 'n' }
const OWNERSHIP = { NATIONAL_GRID: 'national grid' }

const noop = () => { }

const withCleanValue = predicate => value => value.toLowerCase() === predicate

const isAdhocStatus = withCleanValue(STATUS.ADHOC)
const isExistingStatus = withCleanValue(STATUS.EXISTING)
const isOwnershipNationalGrid = withCleanValue(OWNERSHIP.NATIONAL_GRID)

export const ModalAssetBranch = ({ asset = {}, setNestModal = noop, onclickOpen, noCloseIcon, isErrorModalStyle, setIsErrorModalStyle}) => {
  const { status = '', ownership = '' } = asset

  const isAdhocStreetLight = isAdhocStatus(status)
  const isExistingStreetLight = isExistingStatus(status)
  const isOwnedByNationalGrid = isOwnershipNationalGrid(ownership)
  
  // Show the reporting form if this is an existing street light owned by NG
  // or if the street light is adhoc
  if (isAdhocStreetLight || (isExistingStreetLight && isOwnedByNationalGrid))
    return <ReportingForm 
      asset={asset} 
      setNestModal={setNestModal} 
      onclickOpen={onclickOpen} 
      noCloseIcon={noCloseIcon} 
      isErrorModalStyle={isErrorModalStyle} 
      setIsErrorModalStyle={setIsErrorModalStyle} />
  return
}

export default ModalAssetBranch
